import React, { useCallback } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Icon, IconLookup } from '../../Atoms/Icon';
import { DefaultTheme } from '../../Themes';
const StyledContainer = styled.div `
  display: inline-flex;
  align-items: center;
  min-width: 3.75rem;
  max-width: 6.25rem;
  height: 1.833333333rem;
  padding: 0 0.25rem;
  background-color: ${({ theme }) => theme.ThemeColors.LIGHT_GRAY_SURFACE.hex};
  color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
`;
const StyledLabel = styled.span `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledIcon = styled(Icon) `
  height: 100%;
  display: inline-flex;
  align-items: center;
  padding-right: 0.25rem;
  margin-right: 0.333333333rem;
  border-right: 1px solid ${({ theme }) => theme.ThemeColors.TEXT.hex};
`;
const Tag = ({ className = '', isRemovable = false, label, name, onClick = () => { }, onRemove = () => { }, theme = DefaultTheme, }) => {
    const handleRemove = useCallback((event) => {
        onRemove(event, name);
    }, [onRemove, name]);
    const handleClick = useCallback((event) => {
        onClick(event, name);
    }, [onClick, name]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(StyledContainer, { className: className },
            isRemovable && (React.createElement(StyledIcon, { icon: IconLookup.CROSS, onClick: handleRemove, fontSize: '1rem' })),
            React.createElement(StyledLabel, { onClick: handleClick }, label))));
};
export default Tag;
